<template>
  <div v-if="shouldShow" class="verify-banner" role="status">
    <div class="verify-banner-content">
      <span class="verify-banner-icon">🪪</span>
      <span class="verify-banner-text">
        Verify your identity to unlock payments and withdrawals.
      </span>
      <button class="verify-banner-button" @click="goToVerify">
        Verify Identity
      </button>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { getCustomerKycInfo } from "@/api/vivamo-api";

const VERIFIED_STATUSES = ["verified", "verified_manually", "under_review"];

export default {
  name: "VerifyIdentityBanner",
  data() {
    return {
      remoteStatus: null,
      loaded: false,
    };
  },
  computed: {
    ...mapState(["isLoggedIn", "kycStatus"]),
    effectiveStatus() {
      return this.kycStatus || this.remoteStatus;
    },
    shouldShow() {
      if (!this.isLoggedIn || !this.loaded) return false;
      if (this.$route.path === "/verify") return false;
      return !VERIFIED_STATUSES.includes(this.effectiveStatus);
    },
  },
  watch: {
    isLoggedIn: {
      immediate: true,
      handler(loggedIn) {
        if (loggedIn) {
          this.fetchStatus();
        } else {
          this.remoteStatus = null;
          this.loaded = false;
        }
      },
    },
  },
  methods: {
    async fetchStatus() {
      if (this.$route.path === "/verify") {
        this.loaded = true;
        return;
      }
      const userData = JSON.parse(localStorage.getItem("demoUserData") || "{}");
      const username = userData.username;
      if (!username) {
        this.loaded = true;
        return;
      }
      try {
        const info = await getCustomerKycInfo(username);
        this.remoteStatus = info?.kycVerification?.status || null;
      } catch (err) {
        console.warn("Failed to fetch KYC status for banner:", err);
      } finally {
        this.loaded = true;
      }
    },
    goToVerify() {
      this.$router.push("/verify");
    },
  },
};
</script>

<style scoped>
.verify-banner {
  background: linear-gradient(
    90deg,
    rgba(233, 30, 99, 0.9),
    rgba(255, 140, 0, 0.9)
  );
  color: white;
  padding: 0.75rem 1rem;
}

.verify-banner-content {
  max-width: 1100px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
  justify-content: center;
}

.verify-banner-icon {
  font-size: 1.25rem;
}

.verify-banner-text {
  font-size: 0.95rem;
  font-weight: 500;
}

.verify-banner-button {
  background: white;
  color: var(--primary-color);
  border: none;
  padding: 0.5rem 1.1rem;
  border-radius: 20px;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.verify-banner-button:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

@media (max-width: 480px) {
  .verify-banner-text {
    font-size: 0.85rem;
    text-align: center;
  }
}
</style>
